/**
 * @brief   Singleton de AppAjax.
 * @see     resources/js/scripts/functions/AppAjax.class.js
 */
require('./functions/AppAjax.class');
let AppAjax = window.AppAjax;

/*
|--------------------------------------------------------------------------
| DEBUT DU FICHIER - NE RIEN AJOUTER D'AUTRE QUE require() AU DESSUS !
|--------------------------------------------------------------------------
*/

/**
 * @brief   Fonctionnalités de la page des listes de prix
 */
jQuery(document).ready(function() {
    // Exécution du code uniquement si l'élément du DOM existe
    if (jQuery('section[class^=section-price-list]').html() !== undefined) {
        // Méthodes JavaScript communes
        require('./functions/validators.functions');
        // Méthodes jQuery communes
        require('./jquery/upload.jquery');
        /** DEBUT DU CODE JAVASCRIPT EN DESSOUS DE CETTE PARTIE ! */

        //#####################################################
        // Display upload file name
        //#####################################################
        $('.file-input, .file-select').on('change', function() {
            var fileName = $(this).val().split('\\').pop();
            $(this).parents('.file-select:first').find('.display-filename').text(fileName);
        });

        //#####################################################
        // Remove required on other file input when one is set
        //#####################################################
        let $inputs = $('form#confirm-add-pricelist input[type=file]');
        $inputs.on('input', function() {
            $inputs.not(this).prop('required', !$(this).val().length);
        });

        //#####################################################
        // Clear modale content when add new price list
        //#####################################################
        $('button.add-pricelist-btn').on('click', function(event) {
            event.stopPropagation();
            // Clear date/file/text inputs
            $('form#confirm-add-pricelist input[type=text]').each(function() { $(this).val(''); });
            $('form#confirm-add-pricelist input[type=date]').val('');
            $('form#confirm-add-pricelist .file-select').each(function() { $(this).find('.display-filename').text(''); });
            $('form#confirm-add-pricelist input[type=file]').each(function() {
                $(this).val('');
                $(this).prop('required', true);
            });
            // Clear textarea
            $('form#confirm-add-pricelist textarea').each(function() { $(this).val(''); });
            // Clear checkbox list
            $('form#confirm-add-pricelist input[type=checkbox]:checked').each(function() { $(this).click(); });
        });

        //#####################################################
        // Send price list information to the update modale
        //#####################################################
        $('button.update-pricelist-btn').on('click', function(event) {
            event.stopPropagation();
            $('form#confirm-update-pricelist').attr('action', $(this).data('url'));
            // Modal document data
            $('form#confirm-update-pricelist input[name=name]').val($(this).data('name'));
            $('form#confirm-update-pricelist input[name=date]').val($(this).data('date'));
            $('form#confirm-update-pricelist input[name=price]').val($(this).data('price'));
            $('form#confirm-update-pricelist textarea[name=description]').val($(this).data('description'));
            // Clear checkbox list before
            $('form#confirm-update-pricelist input[type=checkbox]:checked').each(function() { $(this).click(); });
            // Convert clients to array
            let clients = $(this).data('clients');
            if (clients.length > 0) {
                let list_clients = clients.split(',');
                // Find clients into array
                $('form#confirm-update-pricelist input[type=checkbox]:not(:checked)').each(function () {
                    let client_id = $(this).val();
                    // Check clients id
                    if (client_id.length > 0 && list_clients.includes(client_id)) {
                        $(this).click();
                    }
                });
            }
        });

        //#####################################################
        // Send delete price list url to the modale form action
        //#####################################################
        $('button.delete-pricelist-btn').on('click', function(event) {
            event.stopPropagation();
            $('form#confirm-delete-pricelist').attr('action', $(this).data('url'));
        });

        //#####################################################
        // Active Select live search
        //#####################################################
        $('.selectpicker').selectpicker();
        var customerSelect = $('select[name="customer"]');
        var displayCustomer = $('.display-company');
        
        customerSelect.on('change', function() {
            var selectedOption = $(this).find('option:selected');
            var selectedOptionText = selectedOption.text();
            var displayCustomerHTML = displayCustomer.html();
        
            // Check if the display div already contains the selected option text
            if (displayCustomerHTML.includes(selectedOptionText)) {
                return;
            }
        
            // If the selected option is not already displayed, add it to the display div
            var selectedOptionHTML = `<div>${selectedOptionText}&nbsp;<i class="bi bi-x"></i></div>`;
            if (displayCustomerHTML) {
                displayCustomer.append(selectedOptionHTML);
            } else {
                displayCustomer.html(selectedOptionHTML);
            }
        
            var deleteButton = displayCustomer.find('.bi-x:last-of-type');
            deleteButton.on('click', function() {
                var parentSpan = $(this).parent();
                parentSpan.remove();
            });
        });
        
        displayCustomer.on('click', '.bi-x', function(event) {
            var parentSpan = $(this).parent();
            parentSpan.remove();
        });
        
        // Get the delete all button element
        var deleteAllButton = $('.delete-all');
        deleteAllButton.on('click', function() {
            var allSelectedOptions = displayCustomer.find('div');
            allSelectedOptions.each(function() {
                $(this).remove();
            });
        });

        /** FIN DU CODE JAVASCRIPT AU DESSUS DE CETTE PARTIE ! */
    }
});
/*
|--------------------------------------------------------------------------
| FIN DU FICHIER - NE RIEN AJOUTER EN DESSOUS !
|--------------------------------------------------------------------------
*/
